import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Protocol } from './protocol';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
    ],
    exports: [],
    providers: []
})
export class CodemeterModule {
    public static readonly WEB_SOCKET_PROTOCOL = 'v1.cmwebsocket.wibu.com';
    public static readonly WEB_SOCKET_HOST = 'ws://localhost:22350/CmWebSocket';
    public static readonly FIRMCODE = 100441;

    public static WebSocketVersion: number = 2;

    public static CreateRequestId(): string {
        return 'request' + Date.now();
    }

    public static DetectProtocol(): Protocol {
        if (window.location.protocol.toLowerCase() === 'https:') {
            return Protocol.https;
        } else {
            return Protocol.http;
        }
    }
}
